const workbenchRouterView = r => require.ensure([], () => r(require('@/page/workbench/workbench')), 'workbenchRouterView');
const messageList = r => require.ensure([], () => r(require('@/page/workbench/message/messageList')), 'messageList');
const addNews = r => require.ensure([], () => r(require('@/page/workbench/news//addNews')), 'addNews');
const myworkList = r => require.ensure([], () => r(require('@/page/workbench/myworkList//myworkList')), 'myworkList');
const maintenanceContract = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/maintenanceContract')), 'maintenanceContract');
const thirdPartyContract = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/thirdPartyContract')), 'thirdPartyContract');
const otherContractDetail = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/otherContractDetail')), 'otherContractDetail');
const thirdPartyContractDetail = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/thirdPartyContractDetail')), 'thirdPartyContractDetail');
const addMaintenanceContact = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/addMaintenanceContact')), 'addMaintenanceContact');
const addThirdPartyContract = r => require.ensure([], () => r(require('@/page/propertyMge/OtherContract/addThirdPartyContract')), 'addThirdPartyContract');
const earlyWaringMore = r => require.ensure([], () => r(require('@/page/earlyWaring/earlyWaringMore')), 'earlyWaringMore');
const earlyWaringDeal = r => require.ensure([], () => r(require('@/page/earlyWaring/earlyWaringDeal/earlyWaringDeal')), 'earlyWaringDeal');

const messageListRouter = {
  path: '',
  component: workbenchRouterView,
  meta: {
    icon: '',
    right: [],
    isShowMenu: false,
  },
  name: '',
  redirect: '/mineRouterView',
  children: [{
      path: '/messageList',
      component: messageList,
      name: '我的消息',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/addNews',
      component: addNews,
      name: '发送消息',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/myworkList',
      component: myworkList,
      name: '工作列表',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/maintenanceContract',
      component: maintenanceContract,
      name: '维修保养合同',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/thirdPartyContract',
      component: thirdPartyContract,
      name: '第三方合同',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/otherContractDetail',
      component: otherContractDetail,
      name: '维修保养合同',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/thirdPartyContractDetail',
      component: thirdPartyContractDetail,
      name: '第三方合同',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/addMaintenanceContact',
      component: addMaintenanceContact,
      name: '维修保养合同新增',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/addThirdPartyContract',
      component: addThirdPartyContract,
      name: '第三方合同新增',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/earlyWaringMore',
      component: earlyWaringMore,
      name: '更多预警',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/earlyWaringDeal',
      component: earlyWaringDeal,
      name: '预警处理',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
  ]
};

export default messageListRouter;